import { component as defineComponent } from 'flightjs';
import withButtonStates from 'entry/mixins/with-button-states';

var selectItemButton = function() {
    this.attributes({
        dataFailedToAddItemEvent: '',
        dataItemsLoadedEvent: '',
        dataItemRemovedEvent: '',
        dataItemAddedEvent: '',
        uiRemoveItemEvent: '',
        uiAddItemEvent: '',
    });

    this.after('initialize', function() {
        this.on('click', this.triggerSelectItem);
        this.on(document, 'dataSelectableItemClicked', this.triggerSelectItem);
        this.on(document, this.attr.dataFailedToAddItemEvent, this.unselectItem);
        this.on(document, this.attr.dataItemsLoadedEvent, this.disableSelection);
        this.on(document, this.attr.dataItemRemovedEvent, this.disableSelection);
        this.on(document, this.attr.dataItemAddedEvent, this.disableSelection);
        this.on(document, this.attr.dataItemsLoadedEvent, this.updateSelectButton);
        this.on(document, 'uiSelectionsUpdated', this.disableSelection);
        this.on(document, 'uiItemSelected', this.selectItem);
        this.on(document, 'uiItemUnselected', this.unselectItem);
    });

    this.selectItem = function(e, data) {
        if (data.id === this.$node.data('id')) {
            this.selectButton(this.$node);
        }
    };

    this.unselectItem = function(e, data) {
        if (data.id === this.$node.data('id')) {
            this.unselectButton(this.$node);
        }
    };

    this.updateSelectButton = function(e, data) {
        var selectedItems = data.selectedItems.map(function(item) {
            return parseInt(item.id, 10);
        });

        if (selectedItems.indexOf(this.$node.data('id')) > -1) {
            this.selectButton(this.$node);
        } else {
            this.unselectButton(this.$node);
        }
    };

    this.disableSelection = function(e, data) {
        if (data.selectedItems.length < this.$node.data('maxSelections')) {
            this.enableButton(this.$node);
        } else {
            var selectedItems = data.selectedItems.map(function(item) {
                return parseInt(item.id, 10);
            });

            if (selectedItems.indexOf(this.$node.data('id')) === -1) {
                this.disableButton(this.$node);
            }

            this.trigger('uiReachedMaximumSelections');
        }
    };

    this.triggerSelectItem = function(e, data) {
        var $data = this.$node.data();

        e.stopPropagation();

        if (data && data.id !== $data.id) {
            return;
        }

        if (this.$node.is('[data-button-disabled]')) {
            return;
        }

        if (!this.$node.is('[data-button-selected]')) {
            this.trigger('uiItemSelected', $data);
            this.trigger(this.attr.uiAddItemEvent, $data);
        } else {
            this.trigger('uiItemUnselected', { id: $data.id });
            this.trigger(this.attr.uiRemoveItemEvent, { id: $data.id });
        }
    };
};

export default defineComponent(selectItemButton, withButtonStates);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/select-item-button.js